<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/F5rtY7/tc-custom/9781453298275.jpg?1733117781575" alt="This image is the cover for the book McNally's Trial, The Archy McNally Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">McNally's Trial, The Archy McNally Series
      </h1>
      <p class="bookDescription body article font2">
        <b>The Palm Beach PI is on the case of a corpse conspiracy. “Lawrence Sanders has honed a voice for Archy McNally that is wonderfully infectious” (<i>The Washington Times</i>).</b><br/><br/> Business is booming at Whitcomb Funeral Homes in southern Florida. Called in to investigate this inexplicable uptick, Palm Beach private investigator Archy McNally finds himself in the middle of a most unusual case.  In the past six months, Whitcomb has shipped out five hundred dead bodies. Why are so many caskets leaving the Sunshine State and being airlifted to New York, Boston, and Chicago? And why did Whitcomb’s comely comptroller come to McNally &amp; Son in the first place? Further complicating McNally’s life are his air-headed buddy, Binky Watrous, who wants to be his private-eye assistant, and his faithful love, Connie Garcia, who’s got her spies when it comes to McNally’s weakness for the ladies. Murder worthy of the headline <i>Death-styles of the Rich and Famous</i> add to McNally’s tribulations. And the next set of human remains could be his.   
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lawrence Sanders
      </h2>
      
      <p class="authorDescription body article">Lawrence Sanders (1920&ndash;1998) was the <i>New York Times </i>bestselling author of more than forty mystery and suspense novels. <i>The Anderson Tapes, </i>completed when he was fifty years old, received an Edgar Award from the Mystery Writers of America for best first novel. His prodigious oeuvre encompasses the Edward X. Delaney, Archy McNally, and Timothy Cone series, along with his acclaimed Commandment books. Stand-alone novels include <i>Sullivan's Sting</i> and <i>Caper.</i> Sanders remains one of America&rsquo;s most popular novelists, with more than fifty million copies of his books in print.&#160;&#160; &#160; &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?17181ca6